import { useEffect } from 'react';
import { clearTimeout, setTimeout } from 'worker-timers';

import { AuthSession } from '../../../../../../../../types';
import { TOKEN_EXPIRY_OFFSET_MS } from '../../../../constants/tokenExiryOffsetMs';

export const useTokensRefresher = (
  authSession: AuthSession,
  refreshTokens: () => void,
): void => {
  useEffect(() => {
    const refresh = () => {
      const { expiresAt } = authSession;

      if (expiresAt) {
        const timeToExpire = new Date(expiresAt).getTime() - Date.now();

        // Refresh the token 10 minutes before it expires to ensure there's a buffer
        const refreshTime = timeToExpire - TOKEN_EXPIRY_OFFSET_MS;

        if (refreshTime > 0) {
          return setTimeout(() => refreshTokens(), refreshTime);
        }
        // If the token is already expired or very close to expiration, refresh immediately
        refreshTokens();
      }

      return null;
    };
    const timerId = refresh();

    return () => {
      // Cleanup on unmount or when authSession changes
      if (timerId) {
        clearTimeout(timerId);
      }
    };
  }, [authSession.expiresAt, refreshTokens]);
};
